import { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";

const NavbarSearchContext = createContext(null);

export function NavbarSearchProvider({ children }) {
  const [searchValue, setSearchValue] = useState("");
  const value = { searchValue, setSearchValue };
  return (
    <NavbarSearchContext.Provider value={value}>
      {children}
    </NavbarSearchContext.Provider>
  );
}

NavbarSearchProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useNavbarSearch() {
  const context = useContext(NavbarSearchContext);
  if (!context) {
    return { searchValue: "", setSearchValue: () => {} };
  }
  return context;
}
